import React from 'react';
import {
  Create,
  SimpleForm,
  TextInput,
  DateInput,
  SelectInput,
  ReferenceInput,
  required,
} from 'react-admin';
import { Grid } from '@mui/material';

const statusChoices = [
  { id: 'completed', name: 'Completed' },
  { id: 'in_progress', name: 'In Progress' },
  { id: 'pending', name: 'Pending' },
  { id: 'dropped', name: 'Dropped' },
];

export const DriverEducationCreate = () => (
  <Create>
    <SimpleForm>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <ReferenceInput source="driverId" reference="drivers">
            <SelectInput optionText={(record: any) => record?.user?.name ? `${record.user.name} (Driver ID: ${record.id})` : `Driver ID: ${record?.id}`} validate={required()} fullWidth />
          </ReferenceInput>
        </Grid>
        <Grid item xs={12} md={6}>
          <ReferenceInput source="educationSchoolId" reference="education-schools">
            <SelectInput optionText="name" validate={required()} />
          </ReferenceInput>
        </Grid>
        <Grid item xs={12} md={6}>
          <TextInput source="programTitle" fullWidth />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextInput source="schoolNameOther" label="Custom School Name" fullWidth />
        </Grid>
        <Grid item xs={12} md={6}>
          <DateInput source="completedDate" fullWidth />
        </Grid>
        <Grid item xs={12} md={6}>
          <SelectInput 
            source="status" 
            choices={statusChoices}
            defaultValue="completed"
            fullWidth
          />
        </Grid>
      </Grid>
    </SimpleForm>
  </Create>
);